import wabvLogo from '../assets/wabv-logo.svg';

// Brand lockup for the public/client-facing pages (upload, eTOE, sign-in card):
// the WABV mark with the wordmark beneath it. The "App" tag distinguishes this
// portal from the main WA Business Valuations website.
export function PublicBrand() {
  return (
    <div className="brand-block">
      <img className="brand-logo-lg" src={wabvLogo} alt="WA Business Valuations" />
      <div className="brand-wordmark">
        <span className="brand-name">WA Business Valuations</span>
        <span className="brand-app">App</span>
      </div>
    </div>
  );
}
